<div class="header">
  <div class="title-wrap">
    <h3 class="title">{{ translationService.getAddExternalRowText() }}</h3>
    <p class="subtitle">
      {{ translationService.getAddExternalRowTooltipText() }}
    </p>
  </div>

  <button
    class="close-btn"
    mat-icon-button
    type="button"
    [attr.aria-label]="translationService.getCloseText()"
    (click)="onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="content">
  <div class="grid">
    <mat-form-field class="col-6" appearance="outline">
      <mat-label>{{ translationService.getMaterialTypeText() }}</mat-label>
      <mat-select [formControl]="typeCtrl" required>
        <mat-option [value]="PLASTIC_MATERIAL_TYPE">
          {{ translationService.getProductMaterialTypePlasticProductText() }}
        </mat-option>
        <mat-option [value]="RAW_RESIN_MATERIAL_TYPE">
          {{ translationService.getRawResinsText() }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-3" appearance="outline">
      <mat-label>{{ translationService.getSkuText() }}</mat-label>
      <input matInput [formControl]="skuCtrl" autocomplete="off" required />
    </mat-form-field>

    <mat-form-field class="col-3" appearance="outline">
      <mat-label>{{ translationService.getSupplierText() }}</mat-label>
      <input matInput [formControl]="supplierCtrl" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="col-8" appearance="outline">
      <mat-label>{{ translationService.getProductNameText() }}</mat-label>
      <input matInput [formControl]="productNameCtrl" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="col-4" appearance="outline">
      <mat-label>{{ translationService.getProductIdentifierText() }}</mat-label>
      <input
        matInput
        [formControl]="productIdentifierCtrl"
        autocomplete="off"
        required
      />
    </mat-form-field>

    @if (typeCtrl.value === PLASTIC_MATERIAL_TYPE) {
      <div class="col-12">
        <mat-checkbox [formControl]="packagingProductCtrl">
          Packaging product
        </mat-checkbox>
      </div>

      <mat-form-field class="col-4" appearance="outline">
        <mat-label>{{ translationService.getCategoryText() }}</mat-label>
        <mat-select [formControl]="categoryCtrl">
          @for (key of categoryKeys; track key) {
            <mat-option [value]="key">{{ categories[key] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="col-4" appearance="outline">
        <mat-label>{{ translationService.getSubcategoryText() }}</mat-label>
        <mat-select
          [formControl]="subCategoryCtrl"
          [disabled]="!categoryCtrl.value || subcategoryKeys.length === 0"
        >
          @for (key of subcategoryKeys; track key) {
            <mat-option [value]="key">{{
              subcategoriesForSelectedCategory[key]
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="col-4" appearance="outline">
      <mat-label>{{ translationService.getMethodUsedText() }}</mat-label>
      <mat-select [formControl]="methodUsedCtrl" required>
        @if (typeCtrl.value === PLASTIC_MATERIAL_TYPE) {
          <mat-option [value]="CALCULATION_METHOD_AVERAGE_BILL_OF_MATERIALS">
            {{ translationService.getCalculationMethodAbomText() }}
          </mat-option>
        }
        <mat-option [value]="CALCULATION_METHOD_FIXED_FACTOR">
          {{ translationService.getCalculationMethodFixedFactorText() }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    @if (typeCtrl.value === RAW_RESIN_MATERIAL_TYPE) {
      <mat-form-field class="col-4" appearance="outline">
        <mat-label>{{ translationService.getProductWeightKgText() }}</mat-label>
        <input matInput type="number" [formControl]="productWeightKgCtrl" />
      </mat-form-field>

      <mat-form-field class="col-4" appearance="outline">
        <mat-label>{{ translationService.getResinTypeText() }}</mat-label>
        <mat-select [formControl]="resinTypeCtrl" required>
          @for (title of napcsResinTitles; track title) {
            <mat-option [value]="title">{{ title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="col-4" appearance="outline">
        <mat-label>{{ translationService.getResinSourceText() }}</mat-label>
        <mat-select [formControl]="resinSourceCtrl" required>
          @for (key of sourceTypeKeys; track key) {
            <mat-option [value]="key">{{ SOURCE_TYPES[key] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (
      typeCtrl.value === PLASTIC_MATERIAL_TYPE &&
      methodUsedCtrl.value === CALCULATION_METHOD_FIXED_FACTOR
    ) {
      <div class="col-12">
        <div class="resins-header">
          <div class="resins-title">
            {{ translationService.getResinsText() }}
          </div>
          <button mat-stroked-button type="button" (click)="addResin()">
            <mat-icon>add</mat-icon>
            {{ translationService.getAddResinText() }}
          </button>
        </div>
      </div>

      @for (
        resinGroup of resinsArray.controls;
        track resinGroup;
        let i = $index
      ) {
        <div class="col-12" [formGroup]="resinGroup">
          <div class="resin-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ translationService.getResinTypeText() }}</mat-label>
              <mat-select formControlName="resinType" required>
                @for (title of napcsResinTitles; track title) {
                  <mat-option [value]="title">{{ title }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{
                translationService.getResinSourceText()
              }}</mat-label>
              <mat-select formControlName="resinSource" required>
                @for (key of sourceTypeKeys; track key) {
                  <mat-option [value]="key">{{ SOURCE_TYPES[key] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{
                translationService.getResinWeightKgText()
              }}</mat-label>
              <input
                matInput
                type="number"
                formControlName="weightPerUnitKg"
                required
              />
            </mat-form-field>

            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="translationService.getRemoveText()"
              (click)="removeResin(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    }
  </div>

  <div class="actions">
    <button mat-stroked-button type="button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
      {{ translationService.getCancelText() }}
    </button>

    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="!canSubmit"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.getAddText() }}
    </button>
  </div>
</div>
